import { CardListCellTypes } from 'src/app/components/pages-partials/card-list/card-list-cell-types.enum';
import { CardListCell } from 'src/app/components/pages-partials/card-list/card-list-cell';
import { EventEmitter, Input, Output, Directive } from '@angular/core';
import { FormAction } from 'src/app/components/action-form/form-action';
import { ColumnSortEvent } from 'src/app/components/dynamic-data-list/services/column-sort.service';
import { sortByColumn } from 'src/app/helpers/array.functions';

@Directive()
export abstract class ProtoList<T> {
    private defaultListActions: FormAction[] = [
        // {
        //     text: 'Select all',
        //     actionHandler: (actionItem: T) => this.selectAll(),
        //     disabled: (actionItem: T) => this.selectedItems.length === this.items.length,
        //     hidden: (_) => !this.selectActive,
        // },
        {
            text: 'Select items',
            actionHandler: (actionItem: T) => this.activateSelect(),
            hidden: (_) => !this.selectable || this.selectActive,
        },
        {
            text: 'Select all on page',
            actionHandler: (actionItem: T) => this.selectAllInView(),
            disabled: (actionItem: T) => this.selectedItems.length === this.totalItems || this.selectableItems.every(item => this.rowSelected(item)),
            hidden: (_) => !this.selectActive || this.selectedItems.length === this.totalItems || this.selectableItems.every(item => this.rowSelected(item)),
        },
        {
            text: 'Unselect all',
            actionHandler: (actionItem: T) => this.clearSelection(),
       
            hidden: (_) => this.selectedItems.length < 1,
        },
    ];

    @Output() linkClick: EventEmitter<T> = new EventEmitter<T>();

    @Input() selectableResolver: (argument: any) => boolean;
    @Input() showMessage: (argument: any) => void;
    @Input() noResult = 'NO_RECORDS';
    @Input() class: string;
    @Input() cellProps: CardListCell[] = [];
    @Input() title: string = null;
    @Input() pagination: boolean = false;
    @Input() selectable: boolean = false;
    @Input() showContextMenu: boolean = false;
    @Input() showTotal: boolean = false;
    @Input() pageSize = 10;
    @Input() page = 1; // Todo: should not be Input
    @Input() paginationMaxSize = 10; // Todo: why is it here?
    @Input() tableSizeClass = '';
    @Input() actionClass = 'dropdown-right mt-2 mr-2';
    @Input() set listActions(actions) {
        this.actions = [...this.defaultListActions, ...actions || [] ];
    }
    @Input() trackBy: (item: T) => any = (item) => item;

    public isLoading: boolean = false;
    public items: T[];
    public selectableItems: T[];
    public totalItems: number = 0;

    public selectedItems: T[] = [];
    public selectActive: boolean = false;
    public actions: FormAction[] = this.defaultListActions;
    public columnTitles: string[] = [];
    public cellTypes = CardListCellTypes;

    public setTitles(cellProps): void {
        this.columnTitles = [];
        cellProps.map(column => this.columnTitles.push(column.title ? column.title : ''));
    }

    public typeResolver(cell: CardListCell, resolverArgs?: any): string {
        if (cell.type === null) return null;
        if (cell.type === CardListCellTypes.text) return 'text';
        if (cell.type === CardListCellTypes.link) return 'link';
        if (cell.type === CardListCellTypes.image) return 'image';
        if (cell.type === CardListCellTypes.icon) return 'icon';
        if (cell.type === CardListCellTypes.statusIcon) return 'statusIcon';
        try {
            var res = cell.type(resolverArgs);
            return res;
        }
        catch { }

        return null;
    }

    public resolveData(cell: CardListCell, resolverArgs?: any): string {
        if (!cell.textResolver) return "";
        return cell.textResolver(resolverArgs);
    }

    public iconResolver(cell: CardListCell, resolverArgs?: any): string {
        return cell.icon ?
            cell.icon :
            cell.iconResolver ? cell.iconResolver(resolverArgs) : '';
    }

    public classResolver(cell: CardListCell, resolverArgs?: any): string {
        return cell.class ?
            cell.class :
            cell.classResolver ? cell.classResolver(resolverArgs) : '';
    }

    public footerResolver(cell: CardListCell, items: any[], selectedItems?: any[]): string {
        try {
            const sum = items.reduce((sum, current) => sum + current[cell.footer], 0);        
            return cell.footerResolver ? cell.footerResolver(items, sum, selectedItems) : sum;
        }
        catch { }
    }

    public clickHandler(e, item, index) {
        e.preventDefault();
        this.cellProps[index].linkHandler ? this.cellProps[index].linkHandler(item, e) : this.linkClick.emit(item);
    }

    public showTitles(): boolean {
        return this.columnTitles.some(item => !!item) && !!this.items;
    }

    public getDisplayItems(): any[] {
        return this.pagination ? this.items.slice((this.page - 1) * this.pageSize, (this.page) * this.pageSize) : this.items;
    }

    public paginationChanged(event: any): void {
        
    }

    public rowSelected(item: T): boolean {
        return this.selectedItems.some(obj => this.trackBy(obj) === this.trackBy(item));
    }

    public toggleSelection(item: T): void {
        if(this.rowSelected(item)) {
            this.selectedItems = this.selectedItems.filter(obj => this.trackBy(obj) !== this.trackBy(item));
        } else {
            this.selectedItems.push(item);
        }
    }

    public clearSelection() {
        this.selectedItems = [];
    }

    public isRowSelectActive(item: T): boolean {
        return this.selectActive && (this.selectableResolver ? this.selectableResolver(item):true);
    }

    protected activateSelect() {           
        this.selectableItems = this.selectableResolver ? this.items.filter((item) => this.selectableResolver(item)) : this.items;
        if (this.selectableItems.length === 0) {
            this.showMessage ? this.showMessage("NO_SELECTABLE") : null;
            console.log("NO_SELECTABLE");
            return;
        }
        this.selectActive = true;
        this.selectAllInView();
    }

    protected selectAllInView() {     
        console.log(this.selectableItems.length);
        console.log(this.selectedItems.length);
          
        let selectedRows = new Set<T>([...this.selectedItems, ...this.selectableItems.slice((this.page - 1) * this.pageSize, (this.page) * this.pageSize)]);
        this.selectedItems = [...selectedRows];
    }

    protected sortItems(items: T[], sortEvent: ColumnSortEvent): T[] {
        return items.sort(sortByColumn(sortEvent));
    }

    private selectAll() {
        this.selectedItems = [...this.selectableItems];
    }

    public hasFooter(): boolean {
        const footer = this.cellProps.filter(x => x.footer);
        return footer.length > 0;
    }
}
